import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { NaturezaVendaFilter } from '../filter';
import { naturezaVendaAtiva, naturezaVendaInativa, NaturezaVendaSituacaoFilterPipe } from '../situacao';
import { NaturezaVendaCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-natureza-venda-multiselect',
    templateUrl: './natureza-venda-multiselect.component.html',
    styleUrls: ['./natureza-venda-multiselect.component.less']
})
export class NaturezaVendaMultiselectComponent implements OnInit {
    /** Natureza de vendas selecionadas */
    @Input() idsNaturezasVendas: number[];
    /** Ao alterar a seleção das naturezas de vendas */
    @Output() idsNaturezasVendasChange = new EventEmitter<number[]>();

    /** Se deve exibir as unidades de negócios ativas */
    @Input() ativas = true;
    /** Se deve exibir as unidades de negócios inativas */
    @Input() inativas = true;
    /** Se deve exibir a opção de selecionar a opção de natureza de venda nula ou seja, para filtrar registros que não possuem a natureza de venda */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar a natureza de venda nula */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção da natureza de venda nula */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Natureza de Venda';
    @Input() checked = 'Natureza de Venda';
    @Input() checkedPlural = 'Naturezas de Vendas';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma natureza de venda encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private naturezaVendaSituacaoFilterPipe: NaturezaVendaSituacaoFilterPipe,
                private naturezaVendaCrudHttpService: NaturezaVendaCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-natureza-venda ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Obtem as situações das naturezas de vendas conforme as opções desejadas */
    private getSituacoes(): number[] {
        const situacoes: number[] = [];
        // Ativas
        if (this.ativas) {
            situacoes.push(naturezaVendaAtiva.id);
        }
        // Inativas
        if (this.inativas) {
            situacoes.push(naturezaVendaInativa.id);
        }

        return situacoes;
    }

    /** Cria as naturezas de vendas para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new NaturezaVendaFilter();
        filter.situacoes = this.getSituacoes();
        this.naturezaVendaCrudHttpService.searchWithFilter(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    // Opção de selecionar a opção de natuerza de venda nula
                    if (this.showNullOption) {
                        selects.push({
                            id: 0,
                            name: 'NÃO INFORMADA'
                        });
                    }

                    // Ativas
                    if (this.ativas) {
                        selects.push({
                            id: -1,
                            name: 'ATIVAS',
                            isLabel: true
                        });

                        this.naturezaVendaSituacaoFilterPipe.transform(entities, naturezaVendaAtiva.id)?.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                    }

                    // Inativas
                    if (this.inativas) {
                        selects.push({
                            id: -2,
                            name: 'INATIVAS',
                            isLabel: true
                        });

                        this.naturezaVendaSituacaoFilterPipe.transform(entities, naturezaVendaInativa.id)?.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                    }

                    this.options = selects;
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar as naturezas de vendas', error);
                }
            );
    }

    /** Ao alterar a seleção da opção da natureza de venda nula */
    private onChangeNullOption() {
        this.nullOption = this.idsNaturezasVendas.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção das naturezas de vendas */
    onChange() {
        this.onChangeNullOption();
        this.idsNaturezasVendasChange.emit(this.idsNaturezasVendas);
    }
}
